import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import Sidebar from '../../components/UI/Sidebar/Sidebar';
import './index.css';

const Main = styled.main`
    transition: all .15s;
`;

export default function Layout(props) {

    const [selected, setSelected]=useState(window.location.pathname.replace(/[/]/g, ''));

    let history = useHistory();
    
    const onSelect = (selecteditem) => {
        setSelected(selecteditem);
        const to = '/' + selecteditem;
        if (window.location.pathname !== to) {
            history.push(to);
        }
    };

    const onToggle = (expanded) => {
        return;
    };

    useEffect(() => { 
        setSelected(window.location.pathname.replace(/[/]/g, ''));
    }, []);

    useEffect(() => { 
        if(props.selectedNavItem === window.location.pathname.replace(/[/]/g, ''))
            { 
                setSelected(props.selectedNavItem);
            }
    }, [props.selectedNavItem]);   
    
    return (
        <div className="layout-container">
            <div className={props.isShowSidebarBottomContents ? "sidebar-container sidebar-with-bottom-contents" : "sidebar-container"}>
               <Sidebar selected={selected} isEditAccess={props.isEditAccess} onSelect={onSelect} onToggle={onToggle} expanded={true} {...props} />
            </div>
            <div className="main-container">
                <Main>
                   { props.children }
                </Main>
            </div>
        </div>
    )
}